import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { Cabecera, Select2Option } from '../../../../shared/models';
import { FormControl, FormGroup, Validators } from '@angular/forms';


interface ListCabecera{
  label: string
  value: string
}
interface FormaPago {
  label: string;
  value: string | null;
}
interface MetodoPago {
  label: string;
  value: string | null;
}

import {
  CatFormaPago,
  CatMetodoPago,
  CatMoneda
} from '../../../../shared/models';
import { map } from 'rxjs';
import { FacturacionService } from '../../../../shared/services/facturacion.service';

let catFormaPago: FormaPago[] = JSON.parse(sessionStorage.getItem("catFormaPago") || '[]');
if (Array.isArray(catFormaPago)) {
  // Verificar si ya existe un objeto con value null
  const exists = catFormaPago.some(item => item.value === null);

  if (!exists) {
    // Agregar un nuevo objeto al principio del array con value null
    catFormaPago.unshift({ label: "Selecciona forma de pago", value: null });
  }
} else {
  //console.error("El valor de catFormaPago no es un array");
  // Inicializar como un array con un nuevo objeto con value null
  catFormaPago = [{ label: "Selecciona forma de pago", value: null }];
}
sessionStorage.setItem("catFormaPago", JSON.stringify(catFormaPago));


let catMetPago: FormaPago[] = JSON.parse(sessionStorage.getItem("catMetodoPago") || '[]');
if (Array.isArray(catMetPago)) {
  // Verificar si ya existe un objeto con value null
  const exists = catMetPago.some(item => item.value === null);

  if (!exists) {
    // Agregar un nuevo objeto al principio del array con value null
    catMetPago.unshift({ label: "Selecciona el método de pago", value: null });
  }
} else {
  
  catMetPago = [{ label: "Selecciona el método de pago", value: null }];
}
sessionStorage.setItem("catMetodoPago", JSON.stringify(catMetPago));


@Component({
  selector: 'app-form-cabecera',
  standalone: false,
  templateUrl: './form-cabecera.component.html',
  styleUrl: './form-cabecera.component.scss'
})


export class FormCabeceraComponent {
  @Output() public send_data_cabecera: EventEmitter<Cabecera> = new EventEmitter<Cabecera>();
  @Output() public send_validation_cabecera: EventEmitter<boolean> = new EventEmitter<boolean>();
  public formCabecera: FormGroup;
  public listTipoComp: ListCabecera[];
  public listIdioma: ListCabecera[];
  public listExportacion: ListCabecera[];
  public CatFormaPago: CatFormaPago[] = [];
  public CatMetodoPago: CatMetodoPago[] = [];
  public CatMoneda: CatMoneda[] = [];
  public customListCatFormaPago: Select2Option[] = [];
  public customListCatMetodoPago: Select2Option[] = [];
  public customListCatMoneda: Select2Option[] = [];
  public isDisabled: boolean = false;
  public catalogosCargados: boolean = true;
  
  constructor(
      private facturacionService: FacturacionService
  ) {
    const catMoneda:any = sessionStorage.getItem("CatMoneda");
    const catFormaPago:any = sessionStorage.getItem("catFormaPago");
    const catMetodoPago:any = sessionStorage.getItem("catMetodoPago");
    this.customListCatMoneda = JSON.parse(catMoneda);
    this.customListCatFormaPago = JSON.parse(catFormaPago);
    this.customListCatMetodoPago = JSON.parse(catMetodoPago);
    this.formCabecera = new FormGroup({
      tipoCfdi: new FormControl(null, [Validators.required]),
      exportacion: new FormControl(null, [Validators.required]),
      referencia: new FormControl(),
      fecha: new FormControl(),
      formaPago: new FormControl(null),
      condicionesDePago: new FormControl(),
      metodoPago: new FormControl(null),
      moneda: new FormControl(null, [Validators.required]),
      idioma: new FormControl('ES', [Validators.required])
    })

    this.listTipoComp = [
      {
        label: "FACTURA",
        value: "FACTURA"
      },
      {
        label: "TRASLADO",
        value: "TRASLADO"
      }
    ]

    this.listIdioma = [
      {
        label: "Español",
        value: "ES"
      },
      {
        label: "Ingles",
        value: "EN"
      }
    ]

    this.listExportacion = [
      {
        label: "01 No aplica",
        value: "01"
      },
      {
        label: "02 Definitiva con clave A1",
        value: "02"
      },
      {
        label: "03 Temporal",
        value: "03"
      },
      {
        label: "04 Definitiva con clave distinta a A1 o cuando no existe enajenación de términos del CFF",
        value: "04"
      }
    ]
  }

  esTraslado(valor: string): boolean {
    return valor === 'TRASLADO';
  }


  public sendCabecera(): void {

    for (const controlName in this.formCabecera.controls) {
      if (this.formCabecera.controls[controlName].value === "") {
        this.formCabecera.controls[controlName].reset();
      }
    }

    // if(this.formCabecera.value['tipoCfdi'] === "TRASLADO"){
    //   console.log("paso por aqui");
      
    //   this.visibleformapago = false;
    //   this.formCabecera.controls['metodoPago'].reset();
    //   this.formCabecera.controls['formaPago'].reset();
  

    //   setTimeout(() => {
    //     this.visibleformapago = true;
    //   }, 500);

    // }

    this.formCabecera.get('tipoCfdi')?.valueChanges.subscribe((value) => {
      if (value === "TRASLADO") {
        this.isDisabled = true;
        this.formCabecera.controls['metodoPago'].reset();
        this.formCabecera.controls['formaPago'].reset();
      } else {
        this.isDisabled = false;
      }
    })
  
    
    
    this.send_data_cabecera.emit(this.formCabecera.value);
    this.send_validation_cabecera.emit(this.formCabecera.valid);
    this.facturacionService.eventSendCabecera.emit(this.formCabecera.value);
  }
  
  public setFormaPago() : void {
    if(this.formCabecera.value['formaPago'] === "99" && this.formCabecera.value['tipoCfdi'] === "FACTURA") {
      this.formCabecera.controls['metodoPago'].setValidators([Validators.required]); // Añade validación requerida
      this.formCabecera.controls['metodoPago'].updateValueAndValidity();
      this.formCabecera.controls['formaPago'].setValidators([Validators.required]); // Añade validación requerida
      this.formCabecera.controls['formaPago'].updateValueAndValidity();
      this.formCabecera.controls['metodoPago'].setValue("PPD");
      
    }

    if(["01","02","03","04","05","06","08","12","13","14","15","17","23","24","25","26","27","28","29","30","31"].includes(this.formCabecera.value['formaPago']) && this.formCabecera.value['tipoCfdi'] === "FACTURA") {
      this.formCabecera.controls['metodoPago'].setValidators([Validators.required]); // Añade validación requerida
      this.formCabecera.controls['metodoPago'].updateValueAndValidity();
      this.formCabecera.controls['formaPago'].setValidators([Validators.required]); // Añade validación requerida
      this.formCabecera.controls['formaPago'].updateValueAndValidity();
      this.formCabecera.controls['metodoPago'].setValue("PUE");
    }

    if(this.formCabecera.value['tipoCfdi'] === "TRASLADO"){
      this.formCabecera.controls['metodoPago'].clearValidators();
      this.formCabecera.controls['formaPago'].clearValidators();
      this.formCabecera.controls['metodoPago'].updateValueAndValidity();
      this.formCabecera.controls['formaPago'].updateValueAndValidity();
    }

    this.sendCabecera();
  }

  public setMetodoPago() : void {
    if(this.formCabecera.value['metodoPago'] === "PPD" && this.formCabecera.value['tipoCfdi'] === "FACTURA") {
      this.formCabecera.controls['metodoPago'].setValidators([Validators.required]); // Añade validación requerida
      this.formCabecera.controls['metodoPago'].updateValueAndValidity();
      this.formCabecera.controls['formaPago'].setValidators([Validators.required]); // Añade validación requerida
      this.formCabecera.controls['formaPago'].updateValueAndValidity();
      this.formCabecera.controls['formaPago'].setValue("99");
    }
    if(this.formCabecera.value['tipoCfdi'] === "TRASLADO"){
      this.formCabecera.controls['metodoPago'].clearValidators();
      this.formCabecera.controls['formaPago'].clearValidators();
      this.formCabecera.controls['metodoPago'].updateValueAndValidity();
      this.formCabecera.controls['formaPago'].updateValueAndValidity();
    }
    this.sendCabecera();
  }

}
